import "@/App.css";
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Signup from "@/pages/Signup";
import Brand from "@/pages/Brand";
import DashboardLayout from "@/pages/DashboardLayout";
import Dashboard from "@/pages/Dashboard";
import Reports from "@/pages/Reports";
import NewReport from "@/pages/NewReport";
import ReportView from "@/pages/ReportView";
import Documents from "@/pages/Documents";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/brand" element={<Brand />} />
            <Route path="/signup" element={<Signup />} />
            <Route
              path="/app"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="reports" element={<Reports />} />
              <Route path="reports/new" element={<NewReport />} />
              <Route path="reports/:id" element={<ReportView />} />
              <Route path="documents" element={<Documents />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Analytics />
    </div>
  );
}

export default App;
